export enum BlAccountServiceTypes {
  BL_T_A = 'BL_T_A', // BL Byrå
  BL_ALL_INCLUSIVE = 'BL_ALL_INCLUSIVE', // helhetslösningstjänsten - Deprecated
  BL_CLIENT_MANAGER = 'BL_CLIENT_MANAGER', // byråstödstjänsten
}
